import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { YearSelect, MonthSelect } from "../../../../helpers/ui/YearSelect";
import { accessRole } from "../../../../helpers/access_role";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import Select from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";
import { cancelToken } from "../../../../services/adapters/kepegawaian/menuService";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import IndexBloc from "../Index/Blocs/IndexBloc";
import CreateBloc from "./Blocs/CreateBloc";

class CreateView extends Component {
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";
  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_nip
    : "";

  createBloc = new CreateBloc();
  indexBloc = new IndexBloc();
  source;
  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      rankOption: [],
      signatoriesOption: [],
      rankFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "rank_id",
          order: "asc",
        },
      },
      signatoriesFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 50,
        sort_order: {
          column: "signatories_official_id",
          order: "asc",
        },
      },
      decree_cp3k_signatories_official_name: "",
      decree_cp3k_signatories_official_nip: "",
      decree_cp3k_adjustment_signatories_official_name: "",
      decree_cp3k_adjustment_signatories_official_nip: "",
    };
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        employee_nip: this.peg_nip,
        decree_cp3k_employee_uuid: this.peg_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "document");
    await this.createBloc.fetchCreate(formData);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  loadSignatoriesList = async () => {
    let offset =
      (this.state.signatoriesFilter.page_number - 1) *
      this.state.signatoriesFilter.page_size;
    const query = {
      search: this.state.signatoriesFilter.filter_value,
      limit: this.state.signatoriesFilter.page_size,
      offset: offset,
      order: this.state.signatoriesFilter.sort_order.column,
      sort: this.state.signatoriesFilter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchSignatories(query, this.source.token);
  };

  loadRankList = async () => {
    let offset =
      (this.state.rankFilter.page_number - 1) * this.state.rankFilter.page_size;
    const query = {
      search: this.state.rankFilter.filter_value,
      limit: this.state.rankFilter.page_size,
      offset: offset,
      order: this.state.rankFilter.sort_order.column,
      sort: this.state.rankFilter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchRankList(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadSignatoriesList();
    this.loadRankList();
  };

  componentDidMount() {
    this.setTokenAPI();

    this.indexBloc.rankListChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ rankOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.signatoriesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ signatoriesOption: result.data.response });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.rankListChannel?.unsubscribe();
    this.indexBloc.signatoriesChannel?.unsubscribe();
    this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    const { result, total } = this.state.rankOption;
    const signatoriesResult = this.state.signatoriesOption?.result;
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="skcp3k" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Tambah SK Calon PPPK</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Golongan Ruang <span className="text-danger">*</span>
                      </Label>
                      <Col md="3">
                        <Select
                          name="decree_cp3k_rank_uuid"
                          errorMessage="Pilih Golongan Ruang"
                          options={result}
                          placeholder="Pilih Golongan Ruang"
                          optionLabel="rank_group_room"
                          optionValue="rank_uuid"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Nomor SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <AvField
                          name="decree_cp3k_decree_number"
                          placeholder="Nomor SK"
                          errorMessage="Masukkan Nomor SK"
                          type="text"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Tanggal SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="3">
                        <AvField
                          name="decree_cp3k_decree_date"
                          placeholder="Tanggal SK"
                          errorMessage="Masukkan Tanggal SK"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        TMT SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="3">
                        <AvField
                          name="decree_cp3k_decree_tmt"
                          placeholder="TMT SK"
                          errorMessage="Masukkan TMT SK"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "66%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Pejabat Penetap SK Calon PPPK</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Pejabat Penetap <span className="text-danger">*</span>
                        </Label>
                        <Col md="8">
                          <Select
                            name="decree_cp3k_signatories_official"
                            errorMessage="Pilih Pejabat Penetap"
                            options={signatoriesResult}
                            placeholder="Pilih Pejabat Penetap"
                            optionLabel="signatories_official_position"
                            optionValue="signatories_official_uuid"
                            validate={{ required: { value: true } }}
                            onChange={(value) => {
                              this.setState({
                                decree_cp3k_signatories_official_name:
                                  value.signatories_official_name,
                                decree_cp3k_signatories_official_nip:
                                  value.signatories_official_nip,
                              });
                            }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Nama Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <AvField
                            name="decree_cp3k_signatories_official_name"
                            placeholder="Nama Pejabat Penetap"
                            errorMessage="Masukkan Nama Pejabat Penetap"
                            type="text"
                            className="form-control"
                            value={
                              this.state.decree_cp3k_signatories_official_name
                            }
                            readOnly
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          NIP Pejabat Penetap{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <AvField
                            name="decree_cp3k_signatories_official_nip"
                            placeholder="NIP Pejabat Penetap"
                            errorMessage="Masukkan NIP Pejabat Penetap"
                            type="text"
                            className="form-control"
                            value={
                              this.state.decree_cp3k_signatories_official_nip
                            }
                            readOnly
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2 col-form-label">
                        Masa Kerja Awal <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        {/* <YearSelect name="decree_cp3k_year_period" /> */}
                        <AvField
                          name="decree_cp3k_year_period"
                          placeholder="Tahun"
                          errorMessage="Masukkan Tahun"
                          type="number"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Label className="col-md-1 col-form-label">Tahun</Label>
                      <Col md="2">
                        {/* <MonthSelect name="decree_cp3k_month_period" /> */}
                        <AvField
                          name="decree_cp3k_month_period"
                          placeholder="Bulan"
                          errorMessage="Masukkan Bulan"
                          type="number"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Label className="col-md-1 col-form-label">Bulan</Label>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Tanggal Tugas <span className="text-danger">*</span>
                      </Label>
                      <Col md="3">
                        <AvField
                          name="decree_cp3k_assignment_date"
                          placeholder="Tanggal Tugas"
                          errorMessage="Masukkan Tanggal Tugas"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Nomor Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <AvField
                          name="decree_cp3k_nota_number"
                          placeholder="Nomor Nota"
                          errorMessage="Masukkan Nomor Nota"
                          type="text"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Tanggal Nota <span className="text-danger">*</span>
                      </Label>
                      <Col md="3">
                        <AvField
                          name="decree_cp3k_nota_date"
                          placeholder="Tanggal Tugas"
                          errorMessage="Masukkan Tanggal Tugas"
                          type="date"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <div
                      style={{
                        width: "66%",
                        border: "1px solid rgb(179, 185, 191)",
                        borderRadius: 4,
                        padding: 10,
                      }}
                    >
                      <Label>Penyesuaian Masa Kerja</Label>
                      <hr />

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          No. SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="9">
                          <AvField
                            name="decree_cp3k_adjustment_decree_number"
                            placeholder="No. SK"
                            errorMessage="Masukkan No. SK"
                            type="text"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Tanggal SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="4">
                          <AvField
                            name="decree_cp3k_adjustment_decree_date"
                            placeholder="Tanggal SK"
                            errorMessage="Masukkan Tanggal SK"
                            type="date"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          TMT SK <span className="text-danger">*</span>
                        </Label>
                        <Col md="4">
                          <AvField
                            name="decree_cp3k_adjustment_decree_tmt"
                            placeholder="TMT SK"
                            errorMessage="Masukkan TMT SK"
                            type="date"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Pejabat Penetap <span className="text-danger">*</span>
                        </Label>
                        <Col md="8">
                          <Select
                            name="decree_cp3k_adjustment_signatories_official"
                            errorMessage="Pilih Pejabat Penetap"
                            options={signatoriesResult}
                            placeholder="Pilih Pejabat Penetap"
                            optionLabel="signatories_official_position"
                            optionValue="signatories_official_uuid"
                            validate={{ required: { value: true } }}
                            onChange={(value) => {
                              this.setState({
                                decree_cp3k_adjustment_signatories_official_name:
                                  value.signatories_official_name,
                                decree_cp3k_adjustment_signatories_official_nip:
                                  value.signatories_official_nip,
                              });
                            }}
                          />
                          <AvField
                            name="decree_cp3k_adjustment_signatories_official_nip"
                            type="hidden"
                            value={
                              this.state
                                .decree_cp3k_adjustment_signatories_official_nip
                            }
                          />
                          <AvField
                            name="decree_cp3k_adjustment_signatories_official_name"
                            type="hidden"
                            value={
                              this.state
                                .decree_cp3k_adjustment_signatories_official_name
                            }
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Masa Kerja Awal <span className="text-danger">*</span>
                        </Label>
                        <Col md="3">
                          {/* <YearSelect name="decree_cp3k_adjustment_year_period" /> */}
                          <AvField
                            name="decree_cp3k_adjustment_year_period"
                            placeholder="Tahun"
                            errorMessage="Masukkan Tahun"
                            type="number"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                        <Label className="col-md-1 col-form-label">Tahun</Label>
                        <Col md="3">
                          {/* <MonthSelect name="decree_cp3k_adjustment_month_period" /> */}
                          <AvField
                            name="decree_cp3k_adjustment_month_period"
                            placeholder="Bulan"
                            errorMessage="Masukkan Bulan"
                            type="number"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                        <Label className="col-md-1 col-form-label">Bulan</Label>
                      </Row>
                    </div>

                    <Row className="mb-3 mt-3">
                      <Label className="col-md-2 col-form-label">
                        File Pendukung
                      </Label>
                      <Col md="6">
                        <FileInput name="document" />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`/kepegawaian/home.html?skcp3k`}>
                          <Button color="danger" type="button">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to={`/kepegawaian/home.html?skcp3k`} />
        ) : null}
      </Fragment>
    );
  }
}

export default CreateView;
